import api from "./api";
import { UI_KEYS } from "./i18nKeys";

export const LANGS = [
  ["fr", "Français"], ["en", "English"], ["de", "Deutsch"], ["nl", "Nederlands"], ["it", "Italiano"], ["es", "Español"],
  ["pt", "Português"], ["cs", "Čeština"], ["sl", "Slovenščina"], ["pl", "Polski"], ["sv", "Svenska"],
];
const DICTS = { fr: {} };
let LANG = "fr";

export const loadDict = async (lang, force = false) => {
  if (!lang || (DICTS[lang] && !force)) return DICTS[lang || "fr"];
  const { data } = await api.get(`/i18n/${lang}`);
  DICTS[lang] = data;
  return data;
};
export const setDictEntry = (lang, key, text) => { DICTS[lang] = { ...(DICTS[lang] || {}), [key]: text }; };
export const setLang = (l) => { LANG = l || "fr"; };
export const getLang = () => LANG;
const LOWER = new WeakMap();
const lowerIndex = (d) => {
  if (!LOWER.has(d)) LOWER.set(d, new Map(Object.keys(d).map((k) => [k.toLowerCase(), k])));
  return LOWER.get(d);
};
// Same translation reused whatever the capitalisation of the French text
const matchCase = (src, out) => {
  if (/\p{L}{2}/u.test(src) && src === src.toUpperCase()) return out.toUpperCase();
  const f = src.charAt(0);
  if (f.toLowerCase() === f.toUpperCase()) return out;
  return (f === f.toLowerCase() ? out.charAt(0).toLowerCase() : out.charAt(0).toUpperCase()) + out.slice(1);
};
export const lookup = (d, s) => {
  if (!d || !s) return "";
  if (d[s]) return d[s];
  const k = lowerIndex(d).get(s.toLowerCase());
  return k && d[k] ? matchCase(s, d[k]) : "";
};
// Clé = texte français ; repli sur le français si la traduction manque.
export const t = (s, lang = LANG) => (lang === "fr" || !s ? s : lookup(DICTS[lang], s) || s);

// "En stock à <ville>" -> translated prefix + unchanged town name
export const localizeSalon = (s = "", lang = LANG) => {
  const m = String(s || "").match(/^En stock à\s+(.+)$/i);
  return m ? `${t("En stock à", lang)} ${m[1]}` : t(s, lang);
};
// Clés dont le texte affiché apparaît dans le texte cliqué (mode traduction).
export const findKeys = (text, lang = LANG) => {
  const norm = (x) => (x || "").replace(/\s+/g, " ").trim().toLowerCase();
  const target = norm(text);
  if (!target) return [];
  const d = DICTS[lang] || {};
  const out = [];
  const seen = new Set();
  for (const [k, v] of [...Object.entries(d), ...UI_KEYS.filter((k) => !d[k]).map((k) => [k, ""])]) {
    if (seen.has(k)) continue;
    seen.add(k);
    const shown = norm(v || k);
    if (shown.length >= 2 && target.includes(shown)) out.push({ key: k, text: v || "", score: shown.length });
  }
  return out.sort((a, b) => b.score - a.score).slice(0, 6);
};
